import React from "react";
import styles from "./report_header_info.module.css";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "main/components/Custom/CustomInput";
import DatePicker from "main/components/DatePicker/DatePicker";
import { updateReportHeader } from "store/actions/remediation_priorities_document/remediationPrioritiesDocumentAction";
import { getAddress } from "main/shared/helpers";

const ReportHeaderInfo = () => {
  const dispatch = useDispatch();
  const { reportData } = useSelector(
    (state) => state.remediationPrioritiesDocument
  );

  const header = reportData?.report_header || {};
  const client = header.client_name || "";
  const property = getAddress(header?.property) || header?.property || "";
  const date = header.date || "";
  const logoUrl = header.business_unit?.logo_url;

  const handleUpdate = (key, value) => {
    dispatch(updateReportHeader({ key, value }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.information_container}>
        <div>
          <InfoRow
            label="Client:"
            input={
              <CustomInput
                value={client}
                parentClassName="clientInput"
                onChange={(e) => handleUpdate("client_name", e.target.value)}
              />
            }
          />
          <InfoRow
            label="Property:"
            input={
              <CustomInput
                value={property}
                parentClassName="propertyInput"
                onChange={(e) => handleUpdate("property", e.target.value)}
              />
            }
          />

          <InfoRow
            label="Date:"
            input={
              <DatePicker
                value={date}
                setValue={(val) => {
                  handleUpdate("date", val);
                }}
                iconPosition="end"
              />
            }
          />
        </div>

        {logoUrl && (
          <div className={styles.company_logo_cont}>
            <img
              className={styles.company_logo}
              src={logoUrl}
              alt="company_logo"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, input }) => (
  <div className={styles.info_section}>
    <div className={styles.info_key}>{label}</div>
    <div className={styles.lead_info}>{input || value}</div>
  </div>
);

export default ReportHeaderInfo;
